import * as React from 'react';
import {InventorySale, InventorySaleEntry} from '../api/dtos/dtos';
import * as dateUtils from '../utils/date-utils';
import {splitIntoChunks} from '../utils/utils';
import {groupNumber, renderFixedPriceColumn} from "../utils/number-utils";
import {getDeliveryMethodLabel} from '../common/DeliveryMethod';
import locales from '../locales';

interface PrintInventorySalePageProps {
  sale: InventorySale;
}

/**
 * Avoid collapsing grid layout content
 */
export function noCollapse(content?: React.ReactNode): React.ReactNode {
  return content ? content : <span>&nbsp;</span>;
}

class PrintInventorySalePage extends React.Component<PrintInventorySalePageProps, {}> {

  public render(): React.ReactNode {
    const entries = this.props.sale.entries || [];
    const chunks: InventorySaleEntry[][] = splitIntoChunks(entries, 10);

    if (chunks.length === 0) {
      return this.renderPage([], 0);
    } else {
      return chunks.map((items, idx) => this.renderPage(items, idx));
    }
  }

  private renderPage = (entries: InventorySaleEntry[], pageIdx: number) => {
    const {sale} = this.props;
    const rightAlignStyle: React.CSSProperties = {textAlign: 'right'};
    const centerAlignStyle: React.CSSProperties = {textAlign: 'center'};

    const entriesSum = entries.map(e => e.cost * (1- (e.discount ?? 0) / 100.0) * e.amount).reduce((a, b) => a + b, 0);

    return (
      <div className="page" key={String(pageIdx)}>

        <p className="label" style={rightAlignStyle}>Azonosító: <b>{sale.saleNumber}</b></p>

        <h1>ELADÁS</h1>

        <p>
          <span className="label">Eladás időpontja:</span>
          <span className="input large">{dateUtils.formatDateOrNull(sale.createdAt)}</span>
          <span className="input large">{dateUtils.formatTimeOrNull(sale.createdAt)}</span>
        </p>

        <div className="grid">
          <div className="elem">
            <p className="label">Vevő neve:</p>
            <p className="input">{noCollapse(sale.client?.name)}</p>
          </div>
          <div className="elem">
            <p className="label">Vevő adószáma:</p>
            <p className="input">{noCollapse(sale.client?.taxNumber)}</p>
          </div>
          <div className="elem">
            <p className="label">Vevő címe:</p>
            <p className="input">{noCollapse([sale.client?.zip, sale.client?.city, sale.client?.address, ].join(', '))}</p>
          </div>
        </div>

        {sale.deliveryMethod && (
          <p>
            <span className="label">{locales.delivery_method}:</span>
            <span className="input">{getDeliveryMethodLabel(sale.deliveryMethod) || sale.deliveryMethod}</span>
          </p>
        )}

        <div style={{height: '24pt'}}/>

        {entries && entries.length > 0 && <>
            <p className="label">Tételek:</p>
            <table style={{marginTop: '2pt'}}>
                <thead>
                <tr>
                    <th>Cikkszám</th>
                    <th>Megnevezés</th>
                    <th>Mennyiség (db)</th>
                    <th>Egységár (Ft)</th>
                    <th>Kedvezmény</th>
                    <th>Összesen (Ft)</th>
                </tr>
                </thead>
                <tbody>
                {entries.map((entry, index) => {
                  const total = entry.amount * entry.cost * (1- (entry.discount ?? 0) / 100.0);
                  const discount = entry.discount ? `${entry.discount} %` : '';
                  return (
                    <tr key={index}>
                      <td style={centerAlignStyle}>{entry.inventoryNumber}</td>
                      <td style={centerAlignStyle}>{entry.name}</td>
                      <td style={centerAlignStyle}>{groupNumber(entry.amount)}</td>
                      <td style={rightAlignStyle}>{renderFixedPriceColumn(entry.cost)}</td>
                      <td style={rightAlignStyle}>{discount}</td>
                      <td style={rightAlignStyle}>{renderFixedPriceColumn(total)}</td>
                    </tr>
                  );
                })}
                </tbody>
            </table>
            <p style={rightAlignStyle}>
                <span className="label">Tételek összesen:</span>
                <span className="input">{renderFixedPriceColumn(entriesSum)}</span>
            </p>
        </>}

        {sale.transportCost != null && sale.transportCost > 0 && (
          <p style={rightAlignStyle}>
            <span className="label">Szállítási költség:</span>
            <span className="input">{renderFixedPriceColumn(sale.transportCost)}</span>
          </p>
        )}

        <div style={{marginTop: 24}} className="grid">
          <p>
            <span className="label">Kelt:</span>
            <span className="input large">Budapest</span>
            <span className="input large">{dateUtils.formatDateOrNull(sale.createdAt)}</span>
          </p>
          <p style={rightAlignStyle}>
            {entries.length > 0 &&
                <span className="label">Összesen:</span>
            }
            <span className="input large">{renderFixedPriceColumn(sale.totalCost)}</span>
          </p>
        </div>

        {sale.comment?.trim() && (
          <div style={{marginTop: 24}}>
            <p className="label">Megjegyzés:</p>
            <p style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{sale.comment}</p>
          </div>
        )}

        <div className="footer">
          <p>Vevő</p>
          <p>Eladó</p>
        </div>
      </div>
    );
  };
}

export default PrintInventorySalePage;



// WEBPACK FOOTER //
// ./src/sales/PrintInventorySalePage.tsx